//https://github.com/Choices-js/Choices/

import {onClick} from '../abstract/helpers.js';
import Choices from 'choices.js'
//import Choices from '../../../node_modules/choices.js/public/assets/scripts/choices.min.js'
//import Choices from '../../../node_modules/choices.js/public/types/src/index.d.ts'

export class CustomSelect {
  constructor() {

    document.jsChoiceList = [];

    var select_list = document.querySelectorAll('.js-choice');
    select_list.forEach(select => {
      var options = {};
      if(select.childElementCount < 8) {
        options.searchEnabled = false;
      } else {
        options.searchEnabled = true;
      }
      document.jsChoiceList.push(new Choices(select, options));
    });
    
  }
}


